module.exports = __webpack_public_path__ + "img/arrow-circle-broken-up-left.8e6d607c.svg";